/**
 * Configuração compartilhada da Google Maps JavaScript API.
 *
 * O `Loader` do @googlemaps/js-api-loader (usado por baixo do `useJsApiLoader`)
 * é um singleton: instanciá-lo com opções diferentes lança
 * "Loader must not be called again with different options". Além disso, o
 * primeiro carregamento da API define quais libraries ficam disponíveis para o
 * resto da aplicação.
 *
 * Por isso a chave e a lista de libraries precisam ser as mesmas em todos os
 * pontos que carregam a API — inclusive nos que não usam o
 * @react-google-maps/api (google-map-react e v3/utils/googleRoute).
 */
export const GOOGLE_MAPS_KEY = import.meta.env.VITE_GOOGLE_MAPS_KEY;

/**
 * Mantenha como constante de módulo. Passar um array novo a cada render faz o
 * loader recarregar sem necessidade.
 *
 * - places: campos de busca de endereço (react-google-autocomplete)
 * - geometry: cálculos de distância/rota
 * - visualization: HeatmapLayer da torre de controle
 * - drawing: desenho de áreas no mapa de viagens
 */
export const GOOGLE_MAPS_LIBRARIES = [
  'places',
  'geometry',
  'visualization',
  'drawing',
];
